import { AppModal } from '@euler/app/components/modal/AppModal';
import { Typography } from '@euler/app/components/typography';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { InspectionSiteInfo } from '@euler/model';
import { array2map } from '@euler/utils/array';
import { usePersistFn } from '@euler/utils/hooks';
import { Picker } from '@react-native-picker/picker';
import { memo, useCallback, useMemo, useState } from 'react';
import { TouchableOpacity } from 'react-native';

export const FacadeSitePickerView = memo(
  ({
    defaultSite,
    sites,
    onSelected,
  }: {
    defaultSite: InspectionSiteInfo;
    sites: InspectionSiteInfo[];
    onSelected: (site: InspectionSiteInfo) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const [site, setSite] = useState(defaultSite);
    const [showSitePicker, setShowSitePicker] = useState(false);
    const map = useMemo(() => array2map(sites, x => x.id), [sites]);

    const onDismissSitePicker = usePersistFn(() => {
      setShowSitePicker(false);
      onSelected(site);
    });

    const onSiteChange = useCallback(
      (siteId: number, _index: number) => {
        setSite(map.get(siteId)!);
      },
      [map],
    );

    return (
      <>
        <TouchableOpacity
          css={`
            background-color: rgba(255, 255, 255, 0.1);
            align-items: center;
            justify-content: center;
            padding: 0 ${rpx(21)}px;
            height: ${rpx(38)}px;
            border-radius: ${rpx(19)}px;
          `}
          onPress={() => setShowSitePicker(true)}
        >
          <Typography.Label
            medium
            size={rpx(19)}
            color="#fff"
            lineHeight={rpx(26)}
          >
            {site.name}
          </Typography.Label>
        </TouchableOpacity>
        <AppModal visible={showSitePicker} onDismiss={onDismissSitePicker}>
          <Picker
            selectedValue={site.id}
            onValueChange={onSiteChange}
            style={{
              flex: 1,
              justifyContent: 'center',
            }}
          >
            {sites.map(item => (
              <Picker.Item
                label={item.name}
                value={item.id}
                key={item.id}
                style={{
                  fontFamily: FontFamily.NotoSans.Regular,
                  fontSize: rpx(14),
                }}
              />
            ))}
          </Picker>
        </AppModal>
      </>
    );
  },
);
